var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 40,
    viewBox: "0 0 69 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 40C31.2397 40 40.25 31.0457 40.25 20C40.25 8.95431 31.2397 0 20.125 0C9.01027 0 0 8.95431 0 20C0 31.0457 9.01027 40 20.125 40Z",
    fill: "#EA001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.875 40C59.9897 40 69 31.0457 69 20C69 8.95431 59.9897 0 48.875 0C37.7603 0 28.75 8.95431 28.75 20C28.75 31.0457 37.7603 40 48.875 40Z",
    fill: "#FFA200",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6bc6f6bd7d0ec700e0b3e57639324c5c.svg";
export { ForwardRef as ReactComponent };